import React from "react";
import { motion } from "framer-motion";
import siteData from "../siteData";

const fadeUp = {
  hidden: { opacity: 0, y: 40, filter: "blur(8px)" },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.8, ease: [0.19, 1, 0.22, 1] },
  },
};

const stagger = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.15 },
  },
};

const cardStagger = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.08 } },
};

const cardAnim = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.5, ease: [0.19, 1, 0.22, 1] },
  },
};

const vp = { once: true, amount: 0.2 };

export default function About() {
  return (
    <section className="about section" id="about">
      <motion.div
        className="container"
        initial="hidden"
        whileInView="visible"
        viewport={vp}
        variants={stagger}
      >
        {/* Watermark */}
        <div className="section-watermark">ABOUT</div>

        <div className="section-header">
          <motion.div variants={fadeUp}>
            <span className="section-tag">About</span>
          </motion.div>
          <motion.h2 className="section-title" variants={fadeUp}>
            A bit about me
          </motion.h2>
          <motion.p className="section-subtitle" variants={fadeUp}>
            Engineer, builder, and lifelong learner.
          </motion.p>
        </div>

        <motion.div className="about-grid" variants={fadeUp}>
          <div className="about-image-wrapper">
            <motion.img
              className="about-image"
              src={siteData.profileImage}
              alt={siteData.name}
              loading="lazy"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.4, ease: [0.19, 1, 0.22, 1] }}
            />
          </div>
          <div className="about-text">
            <h2>{siteData.name}</h2>
            <p>{siteData.aboutBio}</p>

            <motion.div
              className="about-details"
              variants={cardStagger}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <motion.div className="detail-card" variants={cardAnim}>
                <div className="label">Location</div>
                <div className="value">{siteData.location}</div>
              </motion.div>
              <motion.div className="detail-card" variants={cardAnim}>
                <div className="label">Email</div>
                <div className="value">
                  <a href={`mailto:${siteData.email}`}>{siteData.email}</a>
                </div>
              </motion.div>
              <motion.div className="detail-card" variants={cardAnim}>
                <div className="label">Phone</div>
                <div className="value">{siteData.phone}</div>
              </motion.div>
              <motion.div className="detail-card" variants={cardAnim}>
                <div className="label">Education</div>
                <div className="value">{siteData.education.school}</div>
              </motion.div>
            </motion.div>

            <motion.a
              href={siteData.resumeFile}
              download
              className="btn btn-primary"
              whileHover={{
                scale: 1.02,
                boxShadow: "0 0 50px rgba(0,230,138,0.25)",
              }}
              whileTap={{ scale: 0.97 }}
            >
              Download Resume
            </motion.a>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}
